<script>
import Swal from "../../../js/sweetalert2.min.js";

export default {
	beforeMount() {
		this.redirect();
	},
	methods: {
		redirect: function(e) {
			var msg = "마이파랑 회원가입을 환영합니다. \n 잠시 후 자동으로 로그인합니다.";
			Swal.showLoading();
			swal(msg, {
				buttons: false,
				timer: 3000
			}).then(() => {
				location.href = "/";
			});
			Swal.close();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/user/MsgSignup.vue